<template>
  <div class="preview-page-template">
    <Row type="flex" justify="center">
      <i-col :xs="24" class="large" align="center">
        <Card shadow :padding="0" style="min-height: 200px;">
          <div style="min-height: 200px;">
            <div
              v-if="contentDisplay(onboardingVideo)"
              class="image-preview-container"
              :style="{ width: '100%' }"
            >
              <div :style="videoStyle" v-html="contentDisplay(onboardingVideo)" />
            </div>
            <div
              v-if="contentDisplay(onboardingIntro)"
              class="image-preview-container"
              :style="{ width: '100%' }"
            >
              <div :style="introStyle" v-html="contentDisplay(onboardingIntro)" />
            </div>
          </div>
          <div :style="{ padding: '25px 35px 35px' }">
            <Button long type="primary" @click="getStarted()">Get Started</Button>
          </div>
        </Card>
      </i-col>
    </Row>
    <div align="center" :style="{ padding: '10px' }">
      <p>
        <small>Powered By Sharpen &copy; 2019</small>
      </p>
      <p>
        <router-link class="link" :to="redirectLink">Home</router-link>&nbsp;&middot;
        <router-link class="link" :to="redirectLink + '/privacy-policy'">Privacy Policy</router-link>&nbsp;&middot;
        <router-link class="link" :to="redirectLink + '/terms-and-conditions'">Terms of Service</router-link>
      </p>
      <p>
        <small>{{ version }}</small>
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Utils from "@/utils.js";
import Vue from "vue";
import pjson from "@/../package.json";
import _ from "lodash";

import VideoPlayerComponent from "@/components/VideoPlayerComponent";

export default {
  name: "Welcome",
  components: {
    VideoPlayerComponent
  },
  data() {
    return {
      isLoading: false,
      isVideoLoading: false,
      onboardingVideo: null,
      onboardingIntro: null
    };
  },
  computed: {
    ...mapGetters("user", ["userInfo", "brandInfo"]),
    onboardingVideoId() {
      if (_.get(this.brandInfo, "resource_id.onboarding_video"))
        return _.get(this.brandInfo, "resource_id.onboarding_video");
      else if (_.get(this.brandInfo, "network_resource.onboarding_video"))
        return _.get(this.brandInfo, "network_resource.onboarding_video");
      else return _.get(this.brandInfo, "global_resource.onboarding_video");
    },
    onboardingIntroId() {
      if (_.get(this.brandInfo, "resource_id.onboarding_intro"))
        return _.get(this.brandInfo, "resource_id.onboarding_intro");
      else if (_.get(this.brandInfo, "network_resource.onboarding_intro"))
        return _.get(this.brandInfo, "network_resource.onboarding_intro");
      else return _.get(this.brandInfo, "global_resource.onboarding_intro");
    },
    version() {
      return "Version " + pjson.version;
    },
    redirectLink() {
      return "/" + this.$route.params.brandSlug;
    },
    videoStyle() {
      return {
        backgroundColor: this.onboardingVideo.data
          ? this.onboardingVideo.data.backgroundColor
          : "",
        backgroundImage:
          this.onboardingVideo.data && this.onboardingVideo.data.backgroundImage
            ? `url(${this.onboardingVideo.data.backgroundImage})`
            : ""
      };
    },
    introStyle() {
      return {
        marginTop: "20px",
        backgroundColor: this.onboardingIntro.data
          ? this.onboardingIntro.data.backgroundColor
          : "",
        backgroundImage:
          this.onboardingIntro.data && this.onboardingIntro.data.backgroundImage
            ? `url(${this.onboardingIntro.data.backgroundImage})`
            : ""
      };
    }
  },
  mounted() {
    this.getItems();
  },
  watch: {
    userInfo(n, o) {
      if (n) {
        if (!this.brandInfo.id){
          this.$store.dispatch("user/getUserBrandInfo",this.$route.params.brandSlug)
            .then(e => this.getItems())
        }
        else 
          this.getItems();
      }
    }
  },
  methods: {
    getStarted(code, prescription, type) {
      this.$router.replace({
        path: `/${this.$route.params.brandSlug}/login`
      });
    },
    contentDisplay(item) {
      let text = "";
      if (item && item.data) {
        if (item.data.tip) text = Utils.getLinkAddress(item.data.tip);
        else if (item.data.description)
          text = Utils.getLinkAddress(item.data.description);
        else if (item.data.text) text = Utils.getLinkAddress(item.data.text);
      }

      //! TODO - will remove only <br> tags by quill format, not including <br /> or other line break formats
      text = text.replace(/<br>/g, "");
      return text;
    },
    getItems() {
      //get video and intro
      this.$store
        .dispatch("resource/getSingleActivityOnly", this.onboardingVideoId)
        .then(res => {
          this.onboardingVideo = res;
          this.mountVideo();
        });
      this.$store
        .dispatch("resource/getSingleActivityOnly", this.onboardingIntroId)
        .then(res => {
          this.onboardingIntro = res;
          this.mountVideo();
        });
    },
    mountVideo() {
      setTimeout(() => {
        this.mountVideoLoaders();
      }, 400),
        setTimeout(() => {
          this.mountVideoPlayers();
        }, 1500);
    },
    mountVideoLoaders() {
      let videosWithImg = this.$el.querySelectorAll(".ql-editor-video > img");
      if (!videosWithImg) return;

      for (var i = 0; i < videosWithImg.length; i++) {
        let videoImg = videosWithImg[i];

        videoImg.parentElement.parentElement.classList.add("p-relative");

        let loadingNode = document.createElement("div");
        loadingNode.classList.add("video-loader");
        let loader = document.createElement("i");
        loadingNode.appendChild(loader);
        loader.classList.add("fa");
        loader.classList.add("fa-spin");
        loader.classList.add("fa-spinner");
        videoImg.parentElement.appendChild(loadingNode);
      }
    },
    mountVideoPlayers() {
      let videosWithImg = this.$el.querySelectorAll(".ql-editor-video > img");
      if (!videosWithImg) return;

      for (let i = 0; i < videosWithImg.length; i++) {
        let videoImg = videosWithImg[i];
        var videoSrc = ''
        var poster = ''

        var videoSrc = videoImg.parentElement.classList[2].replace('src-', '')
        for (let index = 3; index < videoImg.parentElement.classList.length; index++) {
          if(!videoImg.parentElement.classList[index].startsWith("img-")){
              videoSrc += `+${videoImg.parentElement.classList[index]}`;
          }else{
              poster = videoImg.parentElement.classList[index].replace('img-', '')
              break;
            }
        }

        let isYoutubeVideo = Utils.validateYouTubeUrl(videoSrc);

        let VideoPlayerClass = Vue.extend(VideoPlayerComponent);
        let instance = new VideoPlayerClass({
          propsData: {
            id: "COURSE-QUILL-PLAYER-" + i,
            src: videoSrc,
            poster: poster,
            disabled: this.isEditMode
          }
        });

        instance.$mount();

        videoImg.parentElement.appendChild(instance.$el);
        videoImg.remove();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.ivu-avatar.ivu-avatar-square.ivu-avatar-default.ivu-avatar-image {
  height: 100px;
  width: 100px;
}

.link {
  font-size: 0.8em;
}

.preview-message {
  p {
    font-size: 16px;
  }
}

.large {
  width: 360px;
}

@media (max-width: 750px) {
  .large {
    width: 100%;
  }
}

// @media (min-width: 768px) {
//   .large {
//     margin-top: 35px;
//   }
// }

@media (min-width: 1200px) {
  .large {
    width: 420px;
  }
}
</style>

<style lang="scss">
.preview-page-template {
  .image-preview-container {
    overflow: hidden;
    text-align: center;
    background: transparent;

    img {
      object-fit: cover;
      height: auto;
      width: 100%;
      margin: 0 auto;
    }
  }
}
</style>
